<template>
  <slo-modal :maxWidth="640" @dismiss="cancel()" @formSubmit="save()">
    <template v-slot:title>
      {{ 'Sloan DesignSpec' | t }}
    </template>
    <section v-stack-y:lg>
      <p>{{ 'Please log in or create an account to continue.' | t }}</p>
      <slo-auth />
    </section>
  </slo-modal>
</template>

<script>
import SloModal from '../../../../lib/components/SloModal.vue';
import SloAuth from '../../../../lib/components/SloAuth.vue';
import t from '../../../main/i18n';

export default {
  components: {
    SloModal,
    SloAuth
  },
  filters: {
    t
  },
  methods: {
    cancel() {
      this.$router.back();
    },
    save() {
      this.$router.replace(`/designspec/project/${this.project.id}`);
    }
  }
};
</script>

<style scoped lang="scss">
@import '../../../../scss/variables';
</style>
